import { createAction } from '@reduxjs/toolkit';

export const analyticsBottomNavOnClick = createAction(
    'ANALYTICS::FOOTERV2::CLICK',
);
